import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AffiliateDisclosure from "./AffiliateDisclosure";
import StickyMobileCTA from "./StickyMobileCTA";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <AffiliateDisclosure variant="bar" />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}